import { postAsyncMessage } from 'appBridge/bridge'

export function getContactsFromPhonebook () {
  return postAsyncMessage('contacts')
}
